// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"726a9731","455":"846ab73e","977":"e7f93c79"}[chunkId] + ".chunk.js";
};